/* eslint-disable */

import React from "react";
import * as c3 from "c3";
import "c3/c3.css";

const PieChart = (props) => {
  const { pieChartdata, pieChartProperties, fullScreenValue, uniqueIndex,colSpace } = props;

  let pieColorData = null;

  if (pieChartdata !== undefined) {    
    /* const pieColor = pieChartProperties.piecolor;
    const replaceSquareBrackets = pieChartProperties.piecolor !== undefined ? pieColor.replace(/[\[\]']+/g, "") : "";
    const replaceAllDoubleQuotes = replaceSquareBrackets.replace(/\"/g, "");
    pieColorData = replaceAllDoubleQuotes.split(","); */
    const chart = c3.generate({
      bindto: `#chart${uniqueIndex}`,
      data: {
        columns:fullScreenValue===false?pieChartdata.slice(0,5):pieChartdata,
        type: "pie",
      },
      /* padding: {
              top: 0,
              right: 0,
              bottom: 0,
              left: 100,
          }, */
      /* pie: {
                label: {
                  format: function(value) {
                    if (value / 1000000000 >= 1) {
                      return +(value / 1000000000).toFixed(1) + ' B'
                    } else if (value / 1000000 >= 1) {
                      return +(value / 1000000).toFixed(1) + ' M'
                    } else if (value / 1000 >= 1) {
                      return +(value / 1000).toFixed(1) + ' K'
                    } else {
                      return value
                    }
                  },
                },
              }, */
      /* color: {
        pattern: pieColorData,
      }, */
      legend: {
        position: "right",
        /* inset: {
            anchor: 'top-right',
            x: 50,
            y: 50,
            step: 7
        } */
      },
      size: {
        height:200
      },
      tooltip:{
        show:true
      }
    });
    // leftMenuThreeLines === true ? chart.resize({ height: 320, width: 550 }) : ''
    // window.innerWidth <= 2634 ? chart.resize({ height: 500, width: 1200 }) :''
    /* window.innerWidth <= 1317 ? chart.resize({ height: 230, width: 300 }) :''
          window.innerWidth <= 1646 ? chart.resize({ height: 230, width: 700 }) :'' */
    fullScreenValue === true ? chart.resize({ height: 500, width: 1250 }) : "";
  }
  return (
    <>
      <div id={`chart${uniqueIndex}`} />
    </>
  );
};

export default PieChart;
